class ThemeLoader extends HTMLElement {
  isGlobal = false;
  static classes = {
    active: 'd-flex',
    hidden: 'd-none',
  }
  
  connectedCallback() {
    this.isGlobal = this.dataset.global !== undefined;

    if(this.isGlobal) {
      window.onpageshow = () => {
        this.hide();
      }
      window.onpagehide = () => {
        this.show();
      }
    }
  }
  
  show = () => {
    this.classList.remove(ThemeLoader.classes.hidden);
    this.classList.add(ThemeLoader.classes.active);
  }

  hide = () => {
    this.classList.remove(ThemeLoader.classes.active);
    this.classList.add(ThemeLoader.classes.hidden);
  }
}
if (!window.customElements.get("theme-loader")) {
  window.customElements.define("theme-loader", ThemeLoader);
}


class ScrollingText extends HTMLElement {
  displayed;

  connectedCallback() {
    this.displayed = getComputedStyle(document.documentElement).getPropertyValue("--marquee-elements-displayed");
    this.init();
  }

  init = () => {
    document.documentElement.style.setProperty("--marquee-elements", this.children.length);
    for(var i=0; i<this.displayed; i++){
      this.appendChild(this.children[i].cloneNode(true));
    }
  }
}
if (!window.customElements.get("scrolling-text")) {
  window.customElements.define("scrolling-text", ScrollingText);
}

class ProductCard extends HTMLElement {
  app; swatches; image; url; quickLink; quickSide;
  static QUICKVIEW = '[data-quickview]';
  static SWATCH = '[data-image]';
  static IMAGE = '.primary-image img';
  static ACTIVE = 'border';
  static QUICKSIDE = '#quickview';

  connectedCallback() {
    this.swatches = this.querySelectorAll(ProductCard.SWATCH);
    this.image = this.querySelector(ProductCard.IMAGE);
    this.quickSide = document.querySelector(ProductCard.QUICKSIDE);
    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        this.changeColor(swatch.dataset.image, swatch);
      });
    });
    this.url = this.dataset.url;
    this.quickLink = this.querySelector(ProductCard.QUICKVIEW);
    if(this.quickLink){
      this.quickLink.addEventListener('click', (event) => this.quickView(event));
    }
  }

  quickView = (e) => {
    e.preventDefault();
    axios({
      url: this.url,
      method: 'GET',
    }).then((response) => {
      const doc = Utils.getDocument(response.data);
      const main = doc.querySelector('main-product').parentElement;
      this.quickSide.fill(main.innerHTML);
      this.quickSide.open();
    }).catch((error) => {
      Utils.errorHanlder(error);
    });
  }

  changeColor = (image, swatch) => {
    console.log('changeColor', image, swatch);
    this.image.src = image;
    //elimino srcset e le source in modo che il browser ricarichi le immagini anche da mobile
    this.image.removeAttribute('srcset');
    this.image.parentElement.querySelectorAll("source").forEach((source) => {
      source.remove();
    });
    //aggiorno gli swatch
    this.swatches.forEach((s) => {
      s.classList.remove(ProductCard.ACTIVE);
    });
    swatch.classList.add(ProductCard.ACTIVE);
  }
}
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}

class MainCollection extends HTMLElement {
  canFilter = true; form; loader; filters;
  static FILTER = '[data-filter][data-value]';

  connectedCallback() {
    this.getComponents();
  }

  getComponents = () => {
    this.form = this.querySelector('theme-form');
    this.loader = document.querySelector('theme-loader[data-global]');
    this.filters = this.querySelectorAll(MainCollection.FILTER);
    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', () => {
        this.filter();
      });
    });
    this.form.addEventListener(Utils.E_FORM_SUBMIT, () => {
      this.filter();
    });
    this.querySelector('theme-slider')?.addEventListener(Utils.E_SLIDER_CHANGE, () => {
      this.filter();
    });
  }

  filter = () => {
    const url = this.form.form.getAttribute('action');
    const params = new URLSearchParams(this.form.getData());
    window.history.replaceState({}, '', `${url}?${params.toString()}`);
    this.reload(`${url}?${params.toString()}`);
  }

  reload = (url) => {
    if(this.canFilter) {
      this.loader.show();
      this.canFilter = false;
      axios({
        url: url,
        method: 'GET',
      }).then((response) => {
        const doc = Utils.getDocument(response.data);
        const main = doc.querySelector('main-collection');
        this.innerHTML = main.innerHTML;

        this.getComponents();
      }).catch((error) => {
        Utils.errorHanlder(error);
      }).finally(() => { 
        this.canFilter = true;
        this.loader.hide();
      });
    }
  }
}
if (!window.customElements.get("main-collection")) {
  window.customElements.define("main-collection", MainCollection);
}

class QuickView extends HTMLElement {
  static BODY = '.offcanvas-body';
  body;

  connectedCallback() {
    this.body = this.querySelector(QuickView.BODY);
    window.addEventListener(Utils.E_CART_ADDED, (event) => {
      this.close();
    });
  }

  fill(html){
    this.body.innerHTML = html;
  }

  close = () => {
    const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(this);
    offcanvas.hide();
  }

  open = () => {
    const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(this);
    offcanvas.show();
  }
}
if (!window.customElements.get("quick-view")) {
  window.customElements.define("quick-view", QuickView);
}

class FocalPoint extends HTMLElement {
  swiper; index;

  connectedCallback() {
    this.swiper = document.querySelector(this.dataset.swiper);
    this.index = parseInt(this.dataset.index);
    if(this.swiper){
      this.addEventListener('click', () => this.swipeTo());
    }
  }

  swipeTo(){
    this.swiper.slideTo(this.index);
  }
}
if (!window.customElements.get("focal-point")) {
  window.customElements.define("focal-point", FocalPoint);
}

class QrCode extends HTMLElement {

  connectedCallback() {
    new QRCode(this, {
      text: this.dataset.text,
      width: 120,
      height: 120
    });
  }
}
if (!window.customElements.get("qr-code")) {
  window.customElements.define("qr-code", QrCode);
}

class CopyClick extends HTMLElement {
  text; toast;

  connectedCallback() {
    this.text = this.dataset.text || this.textContent;
    this.toast = this.dataset.toast ? document.querySelector(this.dataset.toast) : null;
    if(this.toast){
      this.toast = bootstrap.Toast.getOrCreateInstance(this.toast)
    }
    this.addEventListener('click', () => this.copy());
  }

  copy = () => {
    navigator.clipboard.writeText(this.text);
    if(this.toast)
      this.toast.show();
  }

}
if (!window.customElements.get("copy-click")) {
  window.customElements.define("copy-click", CopyClick);
}
